"use client";
import "react";
import o from "./index.es65.js";
o.div`
  position: relative;
  ul {
    display: none;
    border: solid 1px black;
    border-top: none;
    background: #fff;
    z-index: 1;
    li {
      display: block;
      padding: 1rem;
    }
    li:focus {
      outline: none;
      background: #f6f6f3;
    }
  }
  &:focus-within {
    ul {
      display: block;
    }
  }
`;
o.ul`
  position: absolute;
  max-height: 300px;
  overflow: auto;
  width: 100%;
  li {
    cursor: pointer;
  }
`;
//# sourceMappingURL=index.es29.js.map
